export enum CourseFor {
    b2c='B2C',
    testUsers='Test Users'
}